import React, { Component } from "react";
import PropTypes from "prop-types";
import has from "lodash.has";

import { isProduction } from "../../utils/config";
import { getParameterByName } from "../../utils/pl";

type Props = {
  render: () => mixed
};

const { Fragment } = React;

// 1. [x]  Check storage for existing user
// 2. [ ]  Create new user
// 3. [ ]  Setup m.me links, pass through context

class UserProvider extends Component<Props> {
  state = {
    user: null,
    error: ""
  };

  componentDidMount() {
    this.initUser();
  }

  setUser = user => {
    this.setState({
      user
    });
  };

  createUser = user => {
    // Store the user in state
    this.setUser(user);

    // Alias and identify them in Mixpanel
    this.context.mixpanel.alias(user.leadId);
    // this.context.mixpanel.identify(user.leadId);

    // Save the user to localStorage
    window.localStorage.setItem("_PL_meta", JSON.stringify(user));
  };

  requestUser = () => {
    // Get ref from querystring
    const ref = getParameterByName("ref") || "";

    const endpoint = isProduction
      ? `https://api.pipeline.social/leads/init/pipeline/${ref}`
      : `https://dev.api.pipeline.social/leads/init/pipeline/${ref}`;

    fetch(endpoint, {
      method: "GET"
    })
      .then(
        response =>
          (response.ok
            ? response.json()
            : new Error("Network response was not ok."))
      )
      .then(response => {
        // If we have a demoLink and a leadId...
        if (has(response, "demoLink") && has(response, "leadId")) {
          this.createUser(response);
        } else {
          throw new Error("No user data returned");
        }
      })
      .catch(error =>
        this.setState({
          error
        })
      );
  };

  initUser = () => {
    const user = this.checkForExistingUser();

    // If we have an existing user...
    if (user) {
      // Store them in state
      this.setUser(user);
      // Identify them in Mixpanel
      // this.context.mixpanel.identify(user.leadId);
      this.context.mixpanel.alias(user.leadId);
    } else {
      // If not create a new user
      this.requestUser();
    }
  };

  checkForExistingUser = () => {
    const user = window.localStorage.getItem("_PL_meta")
      ? JSON.parse(window.localStorage.getItem("_PL_meta"))
      : {};

    return {}.hasOwnProperty.call(user, "leadId") ? user : null;
  };

  render() {
    return <Fragment>{this.props.render(this.state.user)}</Fragment>;
  }
}

UserProvider.contextTypes = { mixpanel: PropTypes.object.isRequired };

export default UserProvider;



// WEBPACK FOOTER //
// ./src/components/providers/UserProvider.jsx